<div class="banner-notification-root">
  <div class="banner-notification-container">
    <mat-icon class="icon">{{icon}}</mat-icon>
    <div class="content"
      [innerHTML]="bannerInfo?.description">
    </div>
  </div>
</div>
